import React, { Component } from "react";

export class Navigation extends Component {
  render() {
    return (
      <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
            >
              {" "}
              <span className="sr-only">Toggle navigation</span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
            </button>
            <a className="navbar-brand page-scroll" href="/">
              <img src="img/logo.png" className="img-responsive" alt=""/>
            </a>{" "}
          </div>

          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav navbar-right">
              {/* <li>
                <a href="#nossos-servicos" className="page-scroll">
                  Nossos Serviços
                </a>
              </li> */}
              <li>
                <a href="#quem-somos" className="page-scroll">
                  Quem Somos
                </a>
              </li>
              <li>
                <a href="#onde-entregamos" className="page-scroll">
                  Onde Entregamos
                </a>
              </li>
              {/* <li>
                <a href="#valores" className="page-scroll">
                  Valores e Prazos
                </a>
              </li> */}
              <li>
                <a href="#fale-conosco" className="page-scroll">
                  Fale Conosco
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navigation;
